var React = require('react');

function ActiveGigs (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/mainNavIcon/Jobs-Active"),React.createElement("g",{"id":"icons/mainNavIcon/Jobs-Active","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("rect",{"id":"Rectangle","stroke":"#9F9EAD","strokeWidth":"2","x":"0","y":"7","width":"30","height":"21","rx":"2","key":0}),React.createElement("polyline",{"id":"Stroke-1","stroke":"#9F9EAD","strokeWidth":"2","points":"21.9402275 13.7646648 13.9316551 21.7646648 9.93938172 17.7766648","key":1}),React.createElement("polyline",{"id":"Rectangle","stroke":"#9F9EAD","strokeWidth":"2","points":"9.13043478 7 9.13043478 2 20.8695652 2 20.8695652 7","key":2})])]);
}

ActiveGigs.defaultProps = {"width":"30px","height":"30px","viewBox":"0 0 30 30","version":"1.1"};

module.exports = ActiveGigs;

ActiveGigs.default = ActiveGigs;
